import generateRTFComponent from '.'

const BasicRTF = generateRTFComponent()

export default BasicRTF
